import { render, staticRenderFns } from "./SignatureStatusBadge.vue?vue&type=template&id=1ae6b2bc&scoped=true"
import script from "./SignatureStatusBadge.vue?vue&type=script&lang=js"
export * from "./SignatureStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./SignatureStatusBadge.vue?vue&type=style&index=0&id=1ae6b2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6b2bc",
  null
  
)

export default component.exports